import { MagnifyingGlassIcon, XIcon } from '@phosphor-icons/react';
import { forwardRef } from 'react';
import { InputField, InputFieldProps } from './Input';

interface SearchInputFieldProps extends Omit<InputFieldProps, 'type' | 'icon'> {}

export const SearchInputField = forwardRef<HTMLInputElement, SearchInputFieldProps>((props, ref) => {
  let { value, ...restProps } = props;
  const hasValue = value && String(value).length > 0;

  const handleIconClick = () => {
    if (hasValue) {
      // Clear the input value by triggering onChange with empty string
      const event = {
        target: { value: '' }
      } as React.ChangeEvent<HTMLInputElement>;
      props.onChange?.(event);
    }
  };

  return (
    // Don't use type="search" as it will cause browser to show their own search input button
    <InputField
      value={value}
      ref={ref}
      placeholder={props.placeholder || 'Search'}
      icon={hasValue ? XIcon : MagnifyingGlassIcon}
      onIconClick={hasValue ? handleIconClick : undefined}
      {...restProps}
    />
  );
});

export default SearchInputField;
